module.exports = __webpack_public_path__ + "static/media/bannerPhone.15112d1c.png";